module.exports = __webpack_public_path__ + "static/media/gamification.1198bdfc.jpg";